import { useClub, useStaff } from "@gymflow/api";
import { useContext, useEffect, useState } from "react";

import { Spinner } from "../components/atoms";
import { usePortalRoutes } from "../hooks/usePortalRoutes";
import { AuthenticatedUserContext, useClubSettings } from "../providers";
import useGymflowModels from "../store";

export function Roadmap() {
  const settings = useClubSettings();
  const clubId = settings.clubId;
  const { api } = useGymflowModels();
  const user = useContext(AuthenticatedUserContext);
  const { data: staff } = useStaff({ api, staffId: user.id });
  const { data: club } = useClub({ api, clubId });
  const { routeId, brand, company } = usePortalRoutes();

  const [isSdkLoaded, setIsSdkLoaded] = useState(false);

  useEffect(() => {
    if (!club || !staff) {
      return;
    }
    const details = {
      organization: "gymflow",

      email: staff.email,
      name: `${staff.firstName} ${staff.lastName}`,
      id: staff.id,

      customFields: {
        brand,
        company,
        routeId,
      },

      companies: [
        {
          id: club.id.toString(),
          name: club.name,
        },
      ],
    } as any;
    if (staff.picture && staff.picture.startsWith("http")) {
      details.profilePicture = staff.picture;
    }
    //@ts-ignore-next-line
    Featurebase("identify", details, (err: unknown) => {
      if (err) {
        throw err;
      }
    
      //@ts-ignore-next-line
      Featurebase(
        "init_embed_widget",
        {
          organization: "gymflow",
          embedOptions: {
            path: "/",
            filters: "",
          },
          stylingOptions: {
            theme: "light",
            hideMenu: false,
            hideLogo: false,
          },
        },
        (err: any, callback: any) => {
          if (callback?.action === "widgetReady") {
            setIsSdkLoaded(true);
          }
        },
      );
    });
  }, [brand, club, company, routeId, staff]);
  return (
    <div className="relative flex h-full w-full">
      <div data-featurebase-embed className="flex h-full w-full"></div>
      {!isSdkLoaded && (
        <div className="absolute inset-0 flex h-full w-full items-center justify-center">
          <Spinner />
        </div>
      )}
    </div>
  );
}
